/**
 * Mock Account Service - Test Implementation
 *
 * Returns mock account/store data for E2E testing.
 * Used when testMode is enabled via URL parameter or localStorage.
 */

import type { Account } from '../types'
import type { IAccountService } from './IAccountService'
import { getMockStores } from 'src/app/modules/product/test-utils/mockData'

export class MockAccountService implements IAccountService {
  /**
   * Get mock accessible accounts
   * Returns predefined mock store data for testing
   */
  async getAccessibleAccounts(useCache?: boolean): Promise<Account[]> {
    console.log('[MockAccountService] Returning mock accessible accounts')

    // Get mock stores from product test utils
    const mockStores = getMockStores()

    // Transform to Account format
    const accounts: Account[] = mockStores.map(store => ({
      id: store.id,
      name: store.name,
      marketplace: store.marketplace as any,
      type: store.marketplace,
      isActive: true,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      logo: store.logo,
      url: store.url
    }))

    // Simulate async operation
    await new Promise(resolve => setTimeout(resolve, 100))

    return accounts
  }
}

export default MockAccountService
